import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export const MetricsSection = styled(Box)(() => ({
  padding: '0 0 8px',
}));

export const KpiRow = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
  gap: 20,
  marginBottom: 24,
}));

export const KpiCard = styled(Paper)(() => ({
  padding: '20px 22px',
  borderRadius: 14,
  border: '1px solid rgba(13, 78, 254, 0.12)',
  background:
    'linear-gradient(135deg, rgba(1, 235, 178, 0.08) 0%, rgba(255, 255, 255, 1) 45%, rgba(13, 78, 254, 0.04) 100%)',
  boxShadow: '0 4px 18px rgba(26, 26, 46, 0.06)',
  marginBottom: 24,
}));

export const KpiCardButton = styled(KpiCard)(() => ({
  display: 'block',
  width: '100%',
  textAlign: 'left',
  cursor: 'pointer',
  font: 'inherit',
  color: 'inherit',
  appearance: 'none',
  WebkitAppearance: 'none',
  transition:
    'box-shadow 0.15s ease, border-color 0.15s ease, transform 0.15s ease',
  '&:hover': {
    borderColor: 'rgba(13, 78, 254, 0.35)',
    boxShadow: '0 6px 20px rgba(13, 78, 254, 0.16)',
    transform: 'translateY(-1px)',
  },
  '&:focus-visible': {
    outline: '2px solid #0d4efe',
    outlineOffset: 2,
  },
}));

export const KpiCardLinkHint = styled(Typography)(() => ({
  marginTop: 10,
  color: '#0d4efe',
  fontWeight: 600,
  fontSize: '0.85rem',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 2,
}));

export const KpiValue = styled(Typography)(() => ({
  fontFamily: "'Exo 2', sans-serif",
  fontWeight: 700,
  fontSize: '2.25rem',
  lineHeight: 1.1,
  color: '#1a1a2e',
  marginBottom: 4,
}));

export const KpiLabel = styled(Typography)(() => ({
  color: '#5a6478',
  fontWeight: 600,
  fontSize: '0.95rem',
}));

export const ChartCard = styled(Paper)(() => ({
  padding: '20px 22px 16px',
  borderRadius: 14,
  border: '1px solid rgba(13, 78, 254, 0.12)',
  backgroundColor: '#fff',
  boxShadow: '0 4px 18px rgba(26, 26, 46, 0.06)',
}));

export const ChartTitle = styled(Typography)(() => ({
  fontWeight: 700,
  color: '#1a1a2e',
  marginBottom: 12,
  display: 'flex',
  alignItems: 'center',
  gap: 8,
}));

export const ChartSvgWrap = styled(Box)(() => ({
  width: '100%',
  overflowX: 'auto',
  marginTop: 8,
  position: 'relative',
}));
